export const GET_FAQ_CATEGORIES_REQUEST = 'GET_FAQ_CATEGORIES_REQUEST'
export const GET_FAQ_CATEGORIES = 'GET_FAQ_CATEGORIES'

export const CREATE_FAQ_CATEGORY_REQUEST = 'CREATE_FAQ_CATEGORY_REQUEST'
export const CREATE_FAQ_CATEGORY = 'CREATE_FAQ_CATEGORY'
export const UPDATE_FAQ_CATEGORY_REQUEST = 'UPDATE_FAQ_CATEGORY_REQUEST'
export const UPDATE_FAQ_CATEGORY = 'UPDATE_FAQ_CATEGORY'
export const DELETE_FAQ_CATEGORY_REQUEST = 'DELETE_FAQ_CATEGORY_REQUEST'
export const DELETE_FAQ_CATEGORY = 'DELETE_FAQ_CATEGORY'

export const CREATE_FAQ_ITEM_REQUEST = 'CREATE_FAQ_ITEM_REQUEST'
export const CREATE_FAQ_ITEM = 'CREATE_FAQ_ITEM'
export const UPDATE_FAQ_ITEM_REQUEST = 'UPDATE_FAQ_ITEM_REQUEST'
export const UPDATE_FAQ_ITEM = 'UPDATE_FAQ_ITEM'
export const DELETE_FAQ_ITEM_REQUEST = 'DELETE_FAQ_ITEM_REQUEST'
export const DELETE_FAQ_ITEM = 'DELETE_FAQ_ITEM'

export const GET_FAQ_REQUEST_PENDING = 'GET_FAQ_REQUEST_PENDING'
export const GET_FAQ_REQUEST_SUCCESS = 'GET_FAQ_REQUEST_SUCCESS'
export const GET_FAQ_REQUEST_ERROR = 'GET_FAQ_REQUEST_ERROR'

export const CHANGE_FAQ_REQUEST_PENDING = 'CHANGE_FAQ_REQUEST_PENDING'
export const CHANGE_FAQ_REQUEST_SUCCESS = 'CHANGE_FAQ_REQUEST_SUCCESS'
export const CHANGE_FAQ_REQUEST_ERROR = 'CHANGE_FAQ_REQUEST_ERROR'
